

var Model = require("../types/Model.js");

module.exports = Model({
	name: "conferenceinviter",
	init: init,
	uninit: uninit,
	listeners: listeners,
	triggers: triggers,

	_contacts: null,
	_managed: null,
	_currently_calling: null,
	rebuild: rebuild,
});

function init() {
	this._contacts = [];
	this._managed = [];
	this._availability = {};
	this._managedContacts = [];

	this.push({
		list: [],
		open: false
	});
}

function uninit() {
	this._contacts = null;
	this._managed = null;
	this._currently_calling = null;
	this._availability = null;
}

function listeners() {
	return {
		"availability:updated": handle_availability_updated,
		"contacts:updated": handle_contacts_updated,
		"managedusers:updated": handle_managed_users_updated,
		"calling:updated": handle_calling_updated,
		"managedcontacts:updated": handle_managecontacts_updated
	};
}

function triggers() {
	return {
		"open": open,
		"close": close,
		"add": add
	};
}

function open() {
	var isOpen = this.data.open;
	if (isOpen) return;
	this.extend({
		open: true
	});
	this.emit("buzz:trigger:video:hide");
	this.emit("usermetrics:trigger:track", "open conference inviter in old calling");
}

function close() {
	var shouldOpen = this.data.open;
	if (!shouldOpen) return;
	this.extend({
		open: false
	});
	this.emit("buzz:trigger:video:show");
	this.emit("usermetrics:trigger:track", "close conference inviter in old calling");
}

function add(data) {
	this.emit("buzz:trigger:conference", data);

	this.emit("usermetrics:trigger:track", "begin conference call in old calling", {
		who: data.who
	});

	var shouldOpen = this.data.open;
	if (!shouldOpen) return;
	this.extend({
		open: false
	});
	this.emit("buzz:trigger:video:show");
}

function rebuild() {
	var list = filterOffline(filter_duplicates(
		this._contacts,
		this._currently_calling
	), this._availability);

	var managedUsersList = filterOffline(filter_duplicates(
		this._managed,
		this._currently_calling
	), this._availability);

	var managedContactsList = filterOffline(filter_duplicates(
		this._managedContacts.filter(filter_self.bind(this)),
		this._currently_calling
	), this._availability);

	this.extend({
		list: list,
		managedUsersList: managedUsersList,
		managedList: managedContactsList
	});
}

function handle_availability_updated(availability) {
	this._availability = availability;
	this.rebuild();
}

function handle_contacts_updated(contacts) {
	this._contacts = contacts;
	this.rebuild();
}

function handle_managed_users_updated(managed) {
	this._managed = managed;
	this.rebuild();
}

function handle_managecontacts_updated(contacts){
	this._managedContacts = contacts;
	this.rebuild();
}

function handle_calling_updated(calling) {
	var who = calling.who || {};
	this._currently_calling = who._id;
	this.rebuild();
}

function filterOffline(list, availability) {
	return list.filter(function (contact) {
		return availability[contact._id];
	});
}

function filter_duplicates(list, existing) {
	var seen = {};
	seen[existing] = true;

	return list.filter(function (item) {
		if (item._id in seen) return false;
		seen[item._id] = true;
		return true;
	});
}

function filter_self(contact){
	var self = this.config.id;
	return self !== contact._id;
}
